import {HStack, Text, VStack} from "@chakra-ui/react";
import * as React from "react";
import {AnimatePresence, motion} from "framer-motion";
import {SignupPageOne} from "./pages/SignupPageOne";
import {SignupPageTwo} from "./pages/SignupPageTwo";
import {SignupPageThree} from "./pages/SignupPageThree";
import {useAppSelector} from "../../hooks/use-store";
import {StepperComponent} from "../../components/atoms/StepperComponent/StepperComponent";
import {useEffect, useState} from "react";
import {SignupPageFour} from "./pages/SignupPageFour";
import {SignupPageSuccess} from "./pages/SignupPageSuccess";
import {SignupPageFive} from "./pages/SignupPageFive";

export const SignupPage = () => {
    const [previousPage, setPreviousPage] = useState(0);
    const {currentPage} = useAppSelector((state) => state.landing);
    const [animationX, setAnimationX] = useState(300);

    useEffect(() => {
        console.log(`${currentPage} - ${previousPage}`);
        setAnimationX(currentPage <= previousPage ? 300 : -300);
        setPreviousPage(currentPage);
    }, [currentPage]);

    return <VStack px={"20%"}>
        <Text variant={"heading"} fontSize={"3vh"} fontStyle={"normal"}
              color={"primary.400"}>Registrati</Text>

        <HStack my={"36px"} alignContent={"center"} justifyContent={"center"}>
            <StepperComponent index={0}/>
            <StepperComponent index={1}/>
            <StepperComponent index={2}/>
            <StepperComponent index={3} hasLine={false}/>
        </HStack>

        <AnimatePresence exitBeforeEnter>
            <motion.div
                key={currentPage}
                style={{width: "100%"}}
                initial={{x: -animationX, opacity: 0}}
                animate={{x: 0, opacity: 1}}
                exit={{x: animationX, opacity: 0}}
                transition={{duration: 0.5}}>
                {currentPage === 0 && <SignupPageOne/>}
                {currentPage === 1 && <SignupPageTwo/>}
                {currentPage === 2 && <SignupPageThree/>}
                {/*{currentPage === 2 && <SignupPageOne/>}*/}
                {currentPage === 3 && <SignupPageFour/>}
                {currentPage === 4 && <SignupPageFive />}
                {currentPage === 5 && <SignupPageSuccess />}
            </motion.div>
        </AnimatePresence>
    </VStack>
}
